import React, { Component } from "react";

import { connect } from 'react-redux';

import { Redirect } from 'react-router';

import Container from 'react-bootstrap/Container';
import {
    Table,
    ScrollArea,
    UnstyledButton,
    Group,
    Text,
    Center,
    TextInput,
    rem,
    keys,
    Button,
    Paper,
    Select,
    Grid,
    Flex,
    Switch,
    Pill,
    Box,
    LoadingOverlay,
    Tooltip
} from '@mantine/core';
import { IconSelector, IconChevronDown, IconChevronUp, IconSearch, IconFilterX, IconPlus } from '@tabler/icons-react';

import { DatePickerInput } from '@mantine/dates';

import contractClasses from './View-Contracts-and-Software.module.css';

import Navbar from '../../components/Navbar';
import classes from '../TableSort.module.css';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';

import dayjs from 'dayjs';

import {Link} from 'react-router-dom';

//import { UPDATE_ACTIVE_LINK } from '../features/actions/Active-Nav-Link-Actions';

//import { ACCESSTOKEN } from '../features/actions/Is-Logged-Actions';

//import { Container } from 'reactstrap';
//import DataTable from '@bit/adeoy.utils.data-table';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSearch, faFilter, faQuestionCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.min.css";
//import { Form } from "react-bootstrap";
import Form from 'react-bootstrap/Form';

import { UPDATE_ACTIVE_LINK } from '../../features/actions/Active-Nav-Link-Actions';
import { LOGOUT } from '../../features/actions/Is-Logged-Actions';
import {
    UPDATE_SELECTED_TYPE,
    UPDATE_SELECTED_WARRANTY_STATUS,
    UPDATE_SELECTED_EXPIRATION_START_DATE,
    UPDATE_SELECTED_EXPIRATION_END_DATE,
    UPDATE_SELECTED_TENANT_ID,
    UPDATE_SELECTED_ASSIGNED_TO_USER,
    UPDATE_SELECTED_SERIAL_NUMBER,
    UPDATE_SELECTED_ASSET_TAG,
    UPDATE_SEARCH_TEXT_HARDWARE_ASSET,
    UPDATE_HARDWARE_ASSET_SORT_BY,
    UPDATE_HARDWARE_ASSET_SORT_ORDER,
    UPDATE_SELECTED_HARDWARE_ASSET_DATA_VIEW,
    UPDATE_SELECTED_HARDWARE_ASSET_CUSTOMER,
    UPDATE_ORDER_PLACEMENT_TIMESPAN,
    UPDATE_SELECTED_ORDER_STATUS,
    UPDATE_HARDWARE_ORDERS_SORT_BY,
    UPDATE_HARDWARE_ORDERS_SORT_ORDER
} from '../../features/actions/Hardware-Asset-Filter-Actions';

import HardwareAssetDataService from '../../services/hardware-asset-activities';
import SoftwareAssetDataService from '../../services/software-asset-activities';    // using getCustomers from this for the customer drop down filter

import authorizedDomainsForTenantChange from '../../authorized-domains-for-tenant-change';

function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th w={props.w} className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.control}>
                <Group justify="space-between">
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}


function filterData(data, search) {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
        keys(data[0]).some((key) => item[key].toLowerCase().includes(query))
    );
}

function sortData(
    data,
    payload
) {
    const { sortBy } = payload;

    if (!sortBy) {
        return filterData(data, payload.search);
    }

    return filterData(
        [...data].sort((a, b) => {
            if (payload.reversed) {
                return b[sortBy].localeCompare(a[sortBy]);
            }

            return a[sortBy].localeCompare(b[sortBy]);
        }),
        payload.search
    );
}


class HardwareAssetList extends Component {

    constructor(props) {
        super(props);

        this.onChangeSearchText = this.onChangeSearchText.bind(this);
        this.openFilterModal = this.openFilterModal.bind(this);
        this.toggleFilterWarrantyDateInputVisible = this.toggleFilterWarrantyDateInputVisible.bind(this);
        this.toggleAddFormAssignedAssetInputVisible = this.toggleAddFormAssignedAssetInputVisible.bind(this);
        this.getHardwareAssetTypes = this.getHardwareAssetTypes.bind(this);
        this.getUserList = this.getUserList.bind(this);
        this.handleWarrantyStatusFilterChange = this.handleWarrantyStatusFilterChange.bind(this);
        this.handleWarrantyStartDateChange = this.handleWarrantyStartDateChange.bind(this);
        this.handleWarrantyEndDateChange = this.handleWarrantyEndDateChange.bind(this);
        this.handleSelectedTypeChange = this.handleSelectedTypeChange.bind(this);
        this.handleSelectedAssignedUserChange = this.handleSelectedAssignedUserChange.bind(this);
        this.handleSerialNumberChange = this.handleSerialNumberChange.bind(this);
        this.handleAssetTagChange = this.handleAssetTagChange.bind(this);
        this.resetFiltersToPreviousValue = this.resetFiltersToPreviousValue.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleColumnClick = this.handleColumnClick.bind(this);
        this.handleAssetTableScroll = this.handleAssetTableScroll.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.handleSelectedTenantChange = this.handleSelectedTenantChange.bind(this);

        this.calculateWarrantyDaysRemaining = this.calculateWarrantyDaysRemaining.bind(this);

        this.goToAssetDetails = this.goToAssetDetails.bind(this);

        this.scrollerRef = React.createRef();

        if(this.props.hardwareAssetFilter.orderPlacementTimespan) {
            var timespan = [this.props.hardwareAssetFilter.orderPlacementTimespan[0] ? dayjs(Date.parse(this.props.hardwareAssetFilter.orderPlacementTimespan[0])).$d : null, this.props.hardwareAssetFilter.orderPlacementTimespan[1] ? dayjs(Date.parse(this.props.hardwareAssetFilter.orderPlacementTimespan[1])).$d : null]
        }

        else {
            var raw_timespan = ["2025-06-01T00:00:00.000Z","2025-06-30T00:00:00.000Z"];
            var timespan = [raw_timespan[0] ? dayjs(Date.parse(raw_timespan[0])).$d : null, raw_timespan[1] ? dayjs(Date.parse(raw_timespan[1])).$d : null]
        }
        // the global state will be definitive copy of filter options chosen. local state handles changes to filter modal not necessarily confirmed
        // global values actually get sent to backend for processing
        this.state = {
            searchText: "",
            typingTimeout: 0,
            resetOffsetTimeout: 0,  // handles the delay in changing asset offset to 0 while user is typing
            show_filter_modal: false,
            enable_warranty_date_input: false,   // determines if the form field for specifying exp date is active in filter modal
            enable_assigned_asset_input: false,  // determines if the form field for assigned asset is active in the add asset modal
            show_add_modal: false,
            types_list: [/* { id: 0, name_of_type: "All" } */],          // will contain array of types {id: 0, name_of_type: "All"}
            tenant_list: [{ id: 0, name_of_tenant: "All" }],     // will contain array of tenants {id: 0, name_of_tenant: "All"}
            user_list: [{ id: 0, full_name: "All", name_of_tenant: "" }, { id: -1, full_name: "Unassigned", name_of_tenant: "" }],      // will contain array of users tech is authorized to see {id: 0, full_name: "All", name_of_tenant: "All Tenants"}

            // local state for filter modal (global state sets default values on componentDidMount)
            selected_type: 0,
            selected_type_name: "",     // the actual text displayed in the device type filter drop down
            selected_warranty_status: "",
            selected_expiration_start_date: "",
            selected_expiration_end_date: "",
            selected_tenant: 0,
            selected_assigned_to_user: 0,
            selected_serial_number: "",
            selected_asset_tag: "",

            // local state for table related sort items (search items are at top of the state object above)
            sort_by: "Name",        // which column is highlighted / which column is sorted on
            sort_order: "ASC",      // ASC or DESC

            // asset list variables
            assets: [],
            rowCount: 0,        // The TOTAL number of assets that could be displayed based on current search params
            scrolled: false,
            assetsToDisplay: [],
            assetOffsetValue: 0,   // the value passed to database to know how many records we've already retrieved by scrolling (increments by 10 each database call)
            numberOfRecordsToShow: 30,   // Will increment by 30 each time user scrolls to bottom of page
            allAssetsShown: false,  // Controls whether to ask for more records

            todaysDate: "",      // will contain the date of today (for comparison with warranty expirations for red text color)

            dataView: false,

            orders: [
                //{order_number: 1, order_name: "Shave and a haircut", po_number: "2344nmb", customer: "LPA", status: "Open", date_placed: "09/15/25"},
                //{order_number: 2, order_name: "Six bits", po_number: "8795kra", customer: "WATG", status: "Archived", date_placed: "10/17/25"}
            ],

            order_sort_by: "Order Number",
            order_sort_order: "ASC",
            customers: [{id: 0, name: "All"}],
            selectedCustomer: "All", // name of the customer user has selected from button list
            selectedCustomerId: 0, // ID of the selected customer from the button list
            timespan: timespan,     // the value for the Order Placement Date range filter
            orderStatusSelected: "All",

            scrollUpdateComplete: true,

            //offset: 0,      // how many orders or assets have already been pulled
            //incrementOffsetBy: 10,      // how many items get pulled with each data retrieval

            authorizedDomainsForTenantChange: authorizedDomainsForTenantChange, /* [
                "prorepro.com", "progroupco.com", "progroupco.org"
            ] */


            /* Values for the asset filters */
            sites: [],
            site_id_selected: 0,
            site_name_selected: null,
            state_selected: "",
            models: [],
            model_name_selected: "",
            model_id_selected: 0,

            show_loading_indicator: false,

        };
    }

    getStatusClasses(status) {
        switch (status) {
          case "Open":
            return [contractClasses.rootActive, contractClasses.labelActive];
          case "Pending":
            return [contractClasses.rootInTransit, contractClasses.labelInTransit];
          case "Cancelled":
            return [contractClasses.rootInActive, contractClasses.labelInActive];
          default:
            return [contractClasses.rootExpired, contractClasses.labelExpired];
        }
    }

    handleAssetTableScroll = (e) => {
        //const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        //console.log("Bottom reached");
        if (window.scrollY === 0) {
            this.setState({ scrollUpdateComplete: true })
        }

        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        //if (bottom) {
        if(windowHeight + scrollTop >= documentHeight - 1) {
            if (this.state.assetOffsetValue < this.state.rowCount && this.state.dataView === false && this.state.scrollUpdateComplete) {        // if we haven't gotten all the assets yet, ask for the next 10
                this.setState({ scrollUpdateComplete: false })
                this.getAssets();
            }

            if (this.state.assetOffsetValue < this.state.rowCount && this.state.dataView === true && this.state.scrollUpdateComplete) {
                this.setState({ scrollUpdateComplete: false })
                this.getOrders();
            }
        }
        //}
    }

    async getAssets() {

        if(this.state.assetOffsetValue === 0) {     // show the loader only when this is a first pull for the set of filters
            this.setState({
                show_loading_indicator: true
            });
        }

        HardwareAssetDataService.getAssets(this.props.loggedStatus.id, this.state.assetOffsetValue, this.props.hardwareAssetFilter.selectedType, this.props.hardwareAssetFilter.warrantyStatus, this.props.hardwareAssetFilter.expirationStartDate, this.props.hardwareAssetFilter.expirationEndDate, this.props.hardwareAssetFilter.selectedAssignedToUser, this.props.hardwareAssetFilter.serialNumber, this.props.hardwareAssetFilter.assetTag, this.props.hardwareAssetFilter.searchTextHardwareAsset, this.props.hardwareAssetFilter.sortBy, this.props.hardwareAssetFilter.sortOrder, this.state.selectedCustomerId, this.state.site_id_selected, this.state.state_selected, this.state.model_id_selected /*this.props.hardwareAssetFilter.selectedTenantId*/)
            .then(response => {
                console.log("You'll be processing returned data here");
                console.log(response);

                // if this is first get with these params, set rowcount and override the previous assets array
                if (this.state.assetOffsetValue === 0) {     // if this was first retreival with these filter params, set the rowCount returned (total possible with those criteria)
                    this.setState({
                        rowCount: response.data.row_count,
                        assets: response.data.results,
                        assetOffsetValue: this.state.assetOffsetValue + 30,
                        show_loading_indicator: false
                    });
                }

                else {  // this was arrived at by a scroll, so add the new results to the previous array

                    this.setState(prevState => ({
                        assets: [...prevState.assets, ...response.data.results],
                        scrollUpdateComplete: true
                    }));

                    this.setState({
                        assetOffsetValue: this.state.assetOffsetValue + 30
                    });

                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    async getOrders() {
        //console.log("In get orders, using offset value: ", this.state.assetOffsetValue);

        if(this.state.assetOffsetValue === 0) {     // show the loader only when this is a first pull for the set of filters
            this.setState({
                show_loading_indicator: true
            });
        }

        HardwareAssetDataService.getHardwareOrders(this.props.loggedStatus.id, this.state.selectedCustomerId /*this.props.hardwareAssetFilter.selectedTenantId*/, this.props.hardwareAssetFilter.hardwareOrdersSortBy, this.props.hardwareAssetFilter.hardwareOrdersSortOrder, this.state.assetOffsetValue, this.state.timespan, this.state.orderStatusSelected, this.props.hardwareAssetFilter.searchTextHardwareAsset) 
        .then(response => {
            console.log("Returned values from get orders endpoint: ", response);

            // this.setState({
            //     orders: response.data.results
            // });

            // Reusing some state variables from assets to save memory
            // if this is first get with these params, set rowcount and override the previous assets array
            if (this.state.assetOffsetValue === 0) {     // if this was first retreival with these filter params, set the rowCount returned (total possible with those criteria)
                this.setState({
                    rowCount: response.data.row_count,
                    orders: response.data.results,
                    assetOffsetValue: this.state.assetOffsetValue + 30,
                    show_loading_indicator: false
                });
            }

            else {  // this was arrived at by a scroll, so add the new results to the previous array

                this.setState(prevState => ({
                    orders: [...prevState.orders, ...response.data.results],
                    scrollUpdateComplete: true
                }));

                this.setState({
                    assetOffsetValue: this.state.assetOffsetValue + 30
                });

            }
        })
        .catch(e => {
            console.log(e);
        })
    }

    onChangeSearchText(e) {
        //const searchText = e.target.value;
        //let searchTextTemp = e.target.value;

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        if (this.state.resetOffsetTimeout) {
            clearTimeout(this.state.resetOffsetTimeout);
        }

        this.setState({
            searchText: e.target.value,

            resetOffsetTimeout: setTimeout(() => {
                console.log("The offset value has been reset");  //this.resetTicketOffset();   // reset the asset offset in state back to 0 (they have changed their search criteria so new list)
            }, 1500),

            typingTimeout: setTimeout(() => {
                // call asset retrieval fxns here
                this.props.UPDATE_SEARCH_TEXT_HARDWARE_ASSET(e.target.value/* this.state.searchText */);
                console.log("You'd be calling the asset retrieval here");
                // this is going to be a new set of filter criteria, so reset the offset
                this.setState({
                    assetOffsetValue: 0
                }, () => {
                    if(this.state.dataView === false) {
                        this.getAssets();
                    }
        
                    else {
                        this.getOrders();
                    }
                });
                //this.getAssets();
            }, 1500)
        });
    }

    // called if user clicks the filter icon. opens filter modal
    openFilterModal() {
        this.setState({
            show_filter_modal: true
        });
    }

    // called when user clicks cancel or x within the filter modal
    closeFilterModal() {
        this.setState({
            show_filter_modal: false
        });

        // after hiding modal reset values to the ones they were before user clicked cancel or x (not necessarily default values)
        this.resetFiltersToPreviousValue();
    }

    openAddModal() {
        this.props.history.push('/createHardwareAsset');
        // this.setState({
        //     show_add_modal: true
        // });
    }

    closeAddModal() {
        this.setState({
            show_add_modal: false
        });
    }

    // determines whether user sees form field for specific warranty exp date within filter modal
    toggleFilterWarrantyDateInputVisible(newValue) {

        if (this.state.enable_warranty_date_input && newValue === false) {
            this.setState({
                enable_warranty_date_input: false
            });
        }

        else if (!this.state.enable_warranty_date_input && newValue === true) {
            this.setState({
                enable_warranty_date_input: true
            });
        }

    }

    // determines whether user sees form field for specific asset a peripheral is assigned to
    toggleAddFormAssignedAssetInputVisible(newValue) {

        if (this.state.enable_assigned_asset_input && newValue === false) {
            this.setState({
                enable_assigned_asset_input: false
            });
        }

        else if (!this.state.enable_assigned_asset_input && newValue === true) {
            this.setState({
                enable_assigned_asset_input: true
            });
        }

    }

    // changeWarrantyDateInputVisible(event) {
    //     console.log(event.target.value);
    // }

    // componentDidMount() {           // token passed into props from the App.js file

    //     if(this.props.loggedStatus.loggedIn){
    //             this.props.onAccessTokenRequest(this.props.loggedStatus.username).then((token) => {
    //             this.props.ACCESSTOKEN(token);
    //             this.retrieveTickets(token);    // PASS TOKEN HERE
    //         });
    //     }

    // }

    // // onChangeSearchName(e) {
    // //     const searchName = e.target.value;

    // //     this.setState({
    // //         searchName: searchName
    // //     });
    // // }

    // retrieveTickets(token) {
    //     HardwareTicketDataService.getAll(token)
    //     .then(response => {
    //         this.setState({
    //             tickets: response.data.results
    //         });
    //         //console.log(response.data.results);
    //     })
    //     .catch(e => {
    //         console.log(e);
    //     });
    // }

    // setActiveTicket(ticket, index) {
    //     this.setState({
    //         currentTicket: ticket,
    //         currentIndex: index
    //     });
    // }

    // searchName() {
    //     TicketDataService.findByName(this.state.searchName)
    //     .then(response => {
    //         this.setState({
    //             tickets: response.data.results
    //         });
    //         //console.log(response.data.results);
    //     })
    //     .catch(e => {
    //         console.log(e);
    //     });
    // }


    componentDidMount() {

        if (this.props.loggedStatus.loggedIn) {
            //this.scrollerRef.current.scrollTop = 0;
            window.addEventListener('scroll', this.handleAssetTableScroll);

            this.setState({
                show_loading_indicator: true
            });
            

            SoftwareAssetDataService.getCustomers(this.props.loggedStatus.primary_tenant_id).then(customerResponse => {
                this.setState({
                    customers: [...this.state.customers, ...customerResponse.data.results],
                    //selectedCustomer: this.props.hardwareAssetFilter.selectedHardwareAssetCustomerName,
                    //selectedCustomerId: this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId,
                });
            })
            // create a date object with today's date (going to use to determine if warranty expiration should be in red font or not)
            var q = new Date();
            // var m = q.getMonth()+1;
            // var d = q.getDay();
            // var y = q.getFullYear();

            // var today = new Date(y,m,d);

            //console.log(today);

            this.setState({
                todaysDate: q
            });

            // this.getHardwareAssetTypes().then(response => {
            //     this.setState({
            //         types_list: [...this.state.types_list, ...response.results]
            //     }, () => {
                    // get the list of users this tech is authorized to view (send the currently selected tenant id through as well)
                    this.getUserList(this.props.loggedStatus.id, this.props.hardwareAssetFilter.selectedTenantId).then(response => {
                        this.setState({
                            user_list: [...this.state.user_list, ...response.results]
                        }, () => {
                            // get the list of tenant names this tech is authorized to view
                            this.getTenantList(this.props.loggedStatus.id).then(response => {

                                // if this is an authorized tenant to view multiple tenant's orders, we're going to use the global state as default
                                // otherwise, we are going to make the selected customer default to the users own tenant
                                let usersTenantName = response.results.find(o => o.id === this.props.loggedStatus.primary_tenant_id).name_of_tenant;
                                let authorizedToChangeTenant = this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase());

                                this.setState({
                                    tenant_list: [...this.state.tenant_list, ...response.results],
                                    selectedCustomer: authorizedToChangeTenant ? this.props.hardwareAssetFilter.selectedHardwareAssetCustomerName : usersTenantName,
                                    selectedCustomerId: authorizedToChangeTenant ? this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId : this.props.loggedStatus.primary_tenant_id,
                                }, async () => {

                                    await this.getFieldDisplaySettings(this.state.selectedCustomerId);
                                    //console.log("JUST BEFORE GETTING TYPES - value of display settings: ", typeDisplaySettings);

                                    let typesResponse = await this.getHardwareAssetTypes(this.state.selectedCustomerId);

                                    if(this.state.selectedCustomerId === 0) {
                                        for(let t = 0; t < typesResponse.results.length; t++) {
                                            if(typesResponse.results[t].tenant_id === null) {
                                                typesResponse.results[t].name_of_type = `${typesResponse.results[t].name_of_type} (All)`;
                                            }

                                            else {
                                                typesResponse.results[t].name_of_type = `${typesResponse.results[t].name_of_type} (${typesResponse.results[t].name_of_tenant})`;
                                            }
                                        }
                                    }

                                    this.setState({
                                        types_list: typesResponse.results //[...this.state.types_list, ...typesResponse.results]
                                    });

                                    let sitesResponse = await this.getSites(this.state.selectedCustomerId);

                                    //console.log("Sites response: ", sitesResponse);

                                    if(this.state.selectedCustomerId === 0) {
                                        for(let s = 0; s < sitesResponse.results.length; s++) {
                                            sitesResponse.results[s].name_of_site = `${sitesResponse.results[s].name_of_site} (${sitesResponse.results[s].name_of_tenant})`
                                        }
                                    }

                                    this.setState({
                                        sites: sitesResponse.results
                                    });

                                    let modelsResponse = await this.getModelsForFilterDropdown(this.state.selectedCustomerId);

                                    if(modelsResponse !== "Error") {
                                        this.setState({
                                            models: modelsResponse.results
                                        });
                                    }

                                    if(this.props.hardwareAssetFilter.dataView === false) {
                                        // reset default filters here so we don't remember past history
                                        await this.resetFiltersToDefaultValues().then(
                                            this.applyFilters()
                                        )

                                        //this.getAssets();
                                    }

                                    else {
                                        console.log("You'll get orders here");
                                        this.getOrders();
                                        // let ordersResponse = await HardwareAssetDataService.getHardwareOrders(token, this.props.loggedStatus.id, this.state.selectedCustomerId, "Order Name", "ASC");
                                        
                                        // console.log("Response from orders endpoint: ", ordersResponse);
                                        // this.setState({
                                        //     orders: ordersResponse.data.results
                                        // });
                                    }
                                })
                            })
                                .catch(e => {
                                    console.log(e);
                                });
                        });
                    })
                        .catch(e => {
                            console.log(e);
                        });
                //});


            // })
            //     .catch(e => {
            //         console.log(e);
            //     });
     

            // NOTE: Per request, we are essentially removing the ability for the search text to be remembered with this line
            this.props.UPDATE_SEARCH_TEXT_HARDWARE_ASSET("");


            // set the local state values for the filter modal based on global state (also search text, sort by and sort order)
            this.setState({
                selected_type: this.props.hardwareAssetFilter.selectedType,
                selected_warranty_status: this.props.hardwareAssetFilter.warrantyStatus,
                selected_expiration_start_date: this.props.hardwareAssetFilter.expirationStartDate,
                selected_expiration_end_date: this.props.hardwareAssetFilter.expirationEndDate,
                selected_tenant: this.props.hardwareAssetFilter.selectedTenantId,
                selected_assigned_to_user: this.props.hardwareAssetFilter.selectedAssignedToUser,
                selected_serial_number: this.props.hardwareAssetFilter.serialNumber,
                selected_asset_tag: this.props.hardwareAssetFilter.assetTag,
                searchText: "",//this.props.hardwareAssetFilter.searchTextHardwareAsset,       NOTE: per request, we are no longer allowing the search text to be remembered between visits to the page
                sort_by: this.props.hardwareAssetFilter.sortBy,
                sort_order: this.props.hardwareAssetFilter.sortOrder,
                dataView: this.props.hardwareAssetFilter.dataView,
                orderStatusSelected: this.props.hardwareAssetFilter.selectedOrderStatus,
                order_sort_by: this.props.hardwareAssetFilter.hardwareOrdersSortBy,
                order_sort_order: this.props.hardwareAssetFilter.hardwareOrdersSortOrder
            });

            this.props.UPDATE_ACTIVE_LINK("hardwareAssetList");
        }



    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleAssetTableScroll);
    }

    getHardwareAssetTypes(tenant_id) {
        return new Promise((resolve, reject) => {

            console.log("In getHardwareAssetTypes with tenant id: ", tenant_id);

            HardwareAssetDataService.getTypes(tenant_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array

                    //console.log("Current value of asset types to show: ", this.state.asset_field_settings.asset_types_to_show);

                    if(this.state.asset_field_settings.asset_types_to_show !== null) {
                        console.log("You'll be setting the specific type selections here");
                        // the string is comma separated, need to turn that into an array for asset_types population
                        // need to use the old default values to determine the id numbers of these

                        const sortedArray = this.state.asset_field_settings.asset_types_to_show
                        .split(",")                       // Split string into an array by comma
                        .map(item => item.trim())         // Remove extra whitespace around items
                        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })); // Case-insensitive sort

                        // go through the original set of asset types that includes all of them and only include ones that appear in the array specified in the settings field
                        const filteredObjects = response.data.results.filter(obj => 
                            sortedArray.includes(obj.name_of_type) || obj.tenant_id === tenant_id
                        );

                        console.log("Original value of specific types to display: ", this.state.asset_field_settings.asset_types_to_show);
                        console.log("Sorted array version: ", sortedArray);
                        console.log("Original full default values: ", response.data.results);

                        // this.setState({
                        //     asset_types: filteredObjects
                        // });

                        //console.log("FILTERED OBJECTS: ", filteredObjects);

                        resolve({results: filteredObjects});
                    }

                    else {
                        // no specifications made, so show all the original default values
                        // this.setState({
                        //     asset_types: response.results
                        // });

                        resolve(response.data);
                    }

                    
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of users this tech is authorized to see for the filter drop down menu
    getUserList(asker_id, tenant_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getUsers(asker_id, tenant_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of tenant names this tech is authorized to see for the filter drop down menu
    getTenantList(asker_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getTenants(asker_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // get the list of locations for the selected tenant - used in the location drop down filter
    getSites(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getSites(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }


    async getModelsForFilterDropdown(tenantId) {
        return new Promise(async (resolve, reject) => {
            let response = await HardwareAssetDataService.getModelsForFilterDropdown(tenantId);

            if(response && response.data) {
                resolve(response.data);
            }

            else {
                console.log("Issue getting models for filter dropdown");
                reject("Error");
            }

        })
    }

    // resets the filters to the values they were before user changed the filter modal (not necessarily default values)
    // called when user clicks the cancel button or x within modal
    resetFiltersToPreviousValue() {
        this.setState({
            selected_type: this.props.hardwareAssetFilter.selectedType,
            selected_warranty_status: this.props.hardwareAssetFilter.warrantyStatus,
            selected_expiration_start_date: this.props.hardwareAssetFilter.expirationStartDate,
            selected_expiration_end_date: this.props.hardwareAssetFilter.expirationEndDate,
            selected_tenant: this.props.hardwareAssetFilter.selectedTenantId,
            selected_assigned_to_user: this.props.hardwareAssetFilter.selectedAssignedToUser,
            selected_serial_number: this.props.hardwareAssetFilter.serialNumber,
            selected_asset_tag: this.props.hardwareAssetFilter.assetTag
        });
    }

    // resets filters to their default values [essentially any "All" values, etc.] (in order to save changes user should click apply to save to global state, etc.)
    resetFiltersToDefaultValues() {
        return new Promise((resolve) => {
            this.setState({
                //user_list: [{id: 0, full_name: "All", name_of_tenant: ""}, {id: -1, full_name: "Unassigned", name_of_tenant: ""}],

                selected_type: 0,
                selected_type_name: null,
                selected_warranty_status: "All",
                selected_expiration_start_date: "",
                selected_expiration_end_date: "",
                selected_tenant: 0,
                selected_assigned_to_user: 0,
                selected_serial_number: "",
                selected_asset_tag: "",

                enable_warranty_date_input: false
            }, () => {
                resolve();
            });
        });
    }

    // gets called when user clicks apply button in the filter modal
    applyFilters() {
        //save local state values to global state
        this.props.UPDATE_SELECTED_TYPE(this.state.selected_type);
        this.props.UPDATE_SELECTED_WARRANTY_STATUS(this.state.selected_warranty_status);
        this.props.UPDATE_SELECTED_EXPIRATION_START_DATE(this.state.selected_expiration_start_date);
        this.props.UPDATE_SELECTED_EXPIRATION_END_DATE(this.state.selected_expiration_end_date);
        this.props.UPDATE_SELECTED_TENANT_ID(this.state.selected_tenant);
        this.props.UPDATE_SELECTED_ASSIGNED_TO_USER(this.state.selected_assigned_to_user);
        this.props.UPDATE_SELECTED_SERIAL_NUMBER(this.state.selected_serial_number);
        this.props.UPDATE_SELECTED_ASSET_TAG(this.state.selected_asset_tag);
        this.props.UPDATE_SEARCH_TEXT_HARDWARE_ASSET(this.state.searchText);

        setTimeout(() => {      // wait for global state to update before getting the next batch of tickets
            this.setState({
                assetOffsetValue: 0
            }, () => this.getAssets());
            //this.getAssets();
        }, 500);

        this.setState({
            show_filter_modal: false
        });
    }

    async handleHardwareAssetCustomerChange(customer_name) {
        if(customer_name !== this.state.selectedCustomer) {
            let newCustomerId = this.state.tenant_list.find(o => o.name_of_tenant === customer_name).id;

            // UPDATE GLOBAL STATE HERE !!!
            this.props.UPDATE_SELECTED_HARDWARE_ASSET_CUSTOMER({customer_id: newCustomerId, customer_name: customer_name});

            // update the asset types in the filter drop down
            await this.getFieldDisplaySettings(newCustomerId);
            //console.log("JUST BEFORE GETTING TYPES - value of display settings: ", typeDisplaySettings);

            //console.log("About to get types for customer with id = ", newCustomerId);

            let typesResponse = await this.getHardwareAssetTypes(newCustomerId);

            //console.log("Types response", typesResponse);

            if(newCustomerId === 0) {
                for(let t = 0; t < typesResponse.results.length; t++) {
                    if(typesResponse.results[t].tenant_id === null) {
                        typesResponse.results[t].name_of_type = `${typesResponse.results[t].name_of_type} (All)`;
                    }

                    else {
                        typesResponse.results[t].name_of_type = `${typesResponse.results[t].name_of_type} (${typesResponse.results[t].name_of_tenant})`;
                    }
                }
            }

            this.setState({
                types_list: typesResponse.results //[...this.state.types_list, ...typesResponse.results]
            });

            let sitesResponse = await this.getSites(newCustomerId);

            //console.log("Sites response: ", sitesResponse);

            if(newCustomerId === 0) {
                for(let s = 0; s < sitesResponse.results.length; s++) {
                    sitesResponse.results[s].name_of_site = `${sitesResponse.results[s].name_of_site} (${sitesResponse.results[s].name_of_tenant})`
                }
            }

            this.setState({
                sites: sitesResponse.results
            });

            let modelsResponse = await this.getModelsForFilterDropdown(newCustomerId);

            this.setState({
                models: modelsResponse.results
            });


            // Reset filters to "" HERE !!!




            this.setState({
                selectedCustomer: customer_name,
                selectedCustomerId: newCustomerId,
                /* These items are involved in resetting the filter options selected */
                selected_type: 0,
                selected_type_name: null,
                site_id_selected: 0,
                site_name_selected: null,
                state_selected: null,
                model_name_selected: null,
                model_id_selected: 0,
                assetOffsetValue: 0
                /* *********************************************************** */
            }, () => {
                //if(this.state.dataView === true) { this.getContracts(); }
                //else { this.getSoftwareAssets(); }
                if(this.state.dataView === false) {
                    //this.getAssets();
                    this.applyFilters();
                }
    
                else {
                    this.getOrders();
                }
            });

        }
    }

    resetAssetFilters() {
        this.setState({
            selected_type: 0,
            selected_type_name: null,
            site_id_selected: 0,
            site_name_selected: null,
            state_selected: null,
            model_name_selected: null,
            model_id_selected: 0,
            assetOffsetValue: 0,
            searchText: "",
        }, () => {
            this.applyFilters();
        })
    }

    handleOrderPlacementTimespanChange(timespan) {
        //let state = store.getState();
    
        if (timespan && timespan !== this.props.hardwareAssetFilter.orderPlacementTimespan && timespan.length > 1 && timespan[1] !== null) {
    
            this.props.UPDATE_ORDER_PLACEMENT_TIMESPAN(timespan);
            //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
            //store.dispatch(updateResolvedTimespan(timespan));
            //store.dispatch(alertResolvedTimespanChange());

            // reset the offset and get orders again
            this.setState({
                assetOffsetValue: 0,
                timespan: timespan
            }, () => {
                this.getOrders();
            })

        }
        //console.log(timespan);
    }

    handleWarrantyStatusFilterChange(e) {
        console.log(e.target.value);
        this.setState({
            selected_warranty_status: e.target.value
        });
    }

    handleWarrantyStartDateChange(e) {
        console.log(e.target.value);
        this.setState({
            selected_expiration_start_date: e.target.value
        });
    }

    handleWarrantyEndDateChange(e) {
        console.log(e.target.value);
        this.setState({
            selected_expiration_end_date: e.target.value
        });
    }

    handleSelectedTypeChange(id) {
        console.log(id);
        this.setState({
            selected_type: id
        });
    }

    async handleSelectedTenantChange(id) {
        console.log(id);
        this.setState({
            selected_tenant: id
        });


        // call for new user list with tenant change
        this.getUserList(this.props.loggedStatus.id, id).then(response => {
            // repopulate the user list
            this.setState({
                user_list: [{ id: 0, full_name: "All", name_of_tenant: "" }, { id: -1, full_name: "Unassigned", name_of_tenant: "" }, ...response.results],
                selected_assigned_to_user: 0
            });
        })
            .catch(e => {
                console.log(e);
            });
    }

    handleSelectedAssignedUserChange(id) {
        console.log(id);
        this.setState({
            selected_assigned_to_user: id
        });
    }

    handleSerialNumberChange(e) {
        this.setState({
            selected_serial_number: e.target.value
        }, () => console.log(this.state.selected_serial_number));

    }

    handleAssetTagChange(e) {
        this.setState({
            selected_asset_tag: e.target.value
        }, () => console.log(this.state.selected_asset_tag));
    }

    handleColumnClick(columnName) {
        // switch the asc, desc value
        if (this.state.sort_order === "ASC") {
            this.setState({
                sort_order: "DESC",
                sort_by: columnName
            });

            this.props.UPDATE_HARDWARE_ASSET_SORT_ORDER("DESC");
            this.props.UPDATE_HARDWARE_ASSET_SORT_BY(columnName);

            //this.getAssets();
        }

        else {
            this.setState({
                sort_order: "ASC",
                sort_by: columnName
            });

            this.props.UPDATE_HARDWARE_ASSET_SORT_ORDER("ASC");
            this.props.UPDATE_HARDWARE_ASSET_SORT_BY(columnName);

            //this.getAssets();
        }

        setTimeout(() => {
            this.setState({
                assetOffsetValue: 0
            }, () => this.getAssets());      // wait for global state to update before getting the next batch of tickets
            //this.getAssets();
        }, 500);
    }

    handleOrderColumnClick(columnName) {
        // switch the asc, desc value
        if (this.state.order_sort_order === "ASC") {
            this.setState({
                order_sort_order: "DESC",
                order_sort_by: columnName
            });

            this.props.UPDATE_HARDWARE_ORDERS_SORT_ORDER("DESC");
            this.props.UPDATE_HARDWARE_ORDERS_SORT_BY(columnName);

        }

        else {
            this.setState({
                order_sort_order: "ASC",
                order_sort_by: columnName
            });

            this.props.UPDATE_HARDWARE_ORDERS_SORT_ORDER("ASC");
            this.props.UPDATE_HARDWARE_ORDERS_SORT_BY(columnName);

        }

        setTimeout(() => {
            this.setState({
                assetOffsetValue: 0
            }, () => this.getOrders());      // wait for global state to update before getting the next batch of orders
        }, 500);
    }

    calculateWarrantyDaysRemaining(expiration_date) {
        if (expiration_date && expiration_date !== null && expiration_date !== "") {
            // create a date object with today's date
            var today = new Date();

            // compare today's date with the date of warranty expiration
            var expiration = new Date(expiration_date.split("T")[0]);

            //console.log(today);
            //console.log(today);
            //console.log(expiration);

            // To calculate the time difference of two dates
            var Difference_In_Time = expiration.getTime() - today.getTime();

            // To calculate the no. of days between two dates
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

            //console.log("Difference in days is: ", Math.round(Difference_In_Days));

            return Math.ceil(Difference_In_Days);

        }

        else {
            return;
        }
    }

    // when this fxn receives a false, we'll be viewing Assets, when it receives a true, we'll be viewing Orders
    // when going from orders to assets, remove the order list from state to save space v.v. when switching the other way
    handleViewChange(new_slider_value) {
        this.setState({
            dataView: new_slider_value,
            assetOffsetValue: 0
        }, () => {
            //if(this.state.dataView === true) { this.getContracts(); }
            //else { this.getSoftwareAssets(); }
            if(this.state.dataView === false) {
                this.getAssets();
            }

            else {
                this.getOrders();
            }
        });

        // update the global state
        this.props.UPDATE_SELECTED_HARDWARE_ASSET_DATA_VIEW(new_slider_value);
    }

    handleOrderStatusChange(selected_status) {
        this.setState({
            orderStatusSelected: selected_status,
            assetOffsetValue: 0
        }, () => {
            if(this.state.dataView === false) {
                this.getAssets();
            }

            else {
                this.getOrders();
            }
        });

        // Set the global state here
        this.props.UPDATE_SELECTED_ORDER_STATUS(selected_status);
    }

    handleDeviceTypeFilterChange(newType) {
        // need to get the id number of the type selected
        const getIdByType = (items, targetName) => {
            return items.find(item => item.name_of_type === targetName)?.id ?? null;
        };

        let typeId = 0;

        if(newType !== null) {
            typeId = getIdByType(this.state.types_list, newType);
        }

        console.log("Type Id = ", typeId);

        this.setState({
            selected_type: typeId,
            selected_type_name: newType
        }, () => {
            this.applyFilters();
        });

    }

    handleSiteFilterChange(newSite) {
        // get the id number of the site selected
        const getIdBySite = (items, targetName) => {
            return items.find(item => item.name_of_site === targetName)?.id ?? null;
        };

        let siteId = 0;

        if(newSite !== null) {
            siteId = getIdBySite(this.state.sites, newSite);
        }

        this.setState({
            site_id_selected: siteId,
            site_name_selected: newSite
        }, () => {
            this.applyFilters();
        });
    }

    handleModelFilterChange(newModel) {
        const getIdByModel = (items, targetName) => {
            return items.find(item => item.name_of_model === targetName)?.id ?? null;
        };

        let modelId = 0;

        if(newModel !== null) {
            modelId = getIdByModel(this.state.models, newModel);
        }

        this.setState({
            model_id_selected: modelId,
            model_name_selected: newModel
        }, () => {
            this.applyFilters();
        });
    }

    handleStateFilterChange(newState) {
        let stateSelected = null;

        if(newState !== null) {
            stateSelected = newState;
        }

        this.setState({
            state_selected: stateSelected
        }, () => {
            this.applyFilters();
        });
    }

    goToAssetDetails(id) {
        this.props.history.push(`/hardwareAssetDetails/${id}`);
    }

    goToOrderDetails(id) {
        this.props.history.push(`/hardwareOrderDetails/${id}`);
    }

    goToAddOrderPage() {
        this.props.history.push(`/createHardwareOrder`);
    }


    async getFieldDisplaySettings(tenantId) {
        try {
            // 1. Wait for the API call to actually finish
            let response = await HardwareAssetDataService.getHardwareAssetFieldSettings(tenantId);

            let newSettings;
            if (response && response.data && response.data.results !== "No settings found") {
                console.log("use the db value", response.data.results[0]);
                newSettings = response.data.results[0];
            } else {
                console.log("use the DEFAULT value");
                newSettings = { asset_types_to_show: null };
            }

            // 2. Wait for setState to complete using a Promise
            await new Promise((resolve) => {
                this.setState({
                    asset_field_settings: newSettings
                }, resolve);
            });

        } catch (error) {
            console.error("Failed to fetch field settings:", error);
        }
        // console.log("Get field settings!");
        // HardwareAssetDataService.getHardwareAssetFieldSettings(tenantId).then(async response => {
        //     let resultToUse;

        //     if(response && response.data && response.data.results !== "No settings found") {
        //         console.log("use the db value", response.data.results[0]);
        //         await new Promise((resolve) => {
        //             this.setState({
        //                 asset_field_settings: response.data.results[0]
        //             }, resolve);
        //         })
        //     }

        //     else {
        //         console.log("use the DEFAULT value");
        //         await new Promise((resolve) => {
        //             this.setState({
        //                 asset_field_settings: {
        //                     asset_types_to_show: null
        //                 }}, resolve);
        //         });
        //     }

        // })
    }
                    


    render() {

        if (!this.props.loggedStatus.loggedIn || (!this.props.userPermissions.can_see_assets && !this.props.userPermissions.can_edit_assets && !this.props.userPermissions.can_add_assets && !this.props.userPermissions.can_delete_assets)) {
            return (
                <Redirect to='/' />
            );
        }

        const stretchLink = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1, // Ensures it sits above the row content
        };

        const rows = this.state.assets && this.state.assets !== undefined && this.state.assets !== "" && this.state.assets.map((asset) => (
            <Table.Tr 
                key={`assetRow${asset.id}`} 
                style={{ position: 'relative' }}
            >
                <Table.Td w="18%">
                    <Link to={`/hardwareAssetDetails/${asset.id}`} style={stretchLink}>
                        <span style={{opacity: 0}}>View Details</span>
                    </Link>
                    {asset.name_of_asset}
                </Table.Td>
                <Table.Td w="10%">{asset.name_of_type}</Table.Td>
                <Table.Td w="10%">{asset.name_of_model}</Table.Td>
                <Table.Td w="15%">
                    {
                        (asset.first_name !== null && asset.middle_name !== null && asset.last_name !== null) ? `${asset.first_name} ${asset.middle_name} ${asset.last_name}` :
                            (asset.first_name !== null && asset.last_name !== null) ? `${asset.first_name} ${asset.last_name}` :
                                `${"Unassigned"}`
                    }
                </Table.Td>
                <Table.Td w="15%">{asset.name_of_site}</Table.Td>
                <Table.Td w="10%">{asset.asset_serial_number}</Table.Td>
                <Table.Td w="10%">{asset.state}</Table.Td>
                {asset.warranty_expiration_date && this.calculateWarrantyDaysRemaining(asset.warranty_expiration_date) <= 0 ?
                    <Table.Td w="12%" style={{ color: "red" }}>{asset.warranty_expiration_date ? `${asset.warranty_expiration_date.split("T")[0]}` : ""}</Table.Td>
                    :
                    asset.warranty_expiration_date && this.calculateWarrantyDaysRemaining(asset.warranty_expiration_date) <= 30 ?
                        <Table.Td w="12%" style={{ color: "orangered" }}>{asset.warranty_expiration_date ? `${asset.warranty_expiration_date.split("T")[0]}` : ""}</Table.Td>
                        :
                        <Table.Td w="12%" style={{ color: "green" }}>{asset.warranty_expiration_date ? `${asset.warranty_expiration_date.split("T")[0]}` : ""}</Table.Td>
                }
            </Table.Tr>
        ))

        const orderRows = this.state.orders && this.state.orders.map((order) => (
            <Table.Tr key={`orderRow${order.order_number}`} className="hardwareOrderTableRow" onClick={() => this.goToOrderDetails(order.order_number)}>
                <Table.Td w="12%">{order.order_number}</Table.Td>
                <Table.Td w="25%">{order.order_name}</Table.Td>
                <Table.Td w="18%">{order.po_number}</Table.Td>
                <Table.Td w="20%">{order.customer}</Table.Td>
                <Table.Td w="15%">{order.date_placed}</Table.Td>
                <Table.Td w="10%">
                    {order.status !== null ?
                        <Pill className={this.getStatusClasses(order.status)}>{order.status}</Pill>
                        :
                        undefined
                    }
                </Table.Td>
                
            </Table.Tr>
        ))


        return (
            <>
                <Navbar pageTitle={"Hardware Assets and Orders"} />
                <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
                <Container fluid >
                {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ?
                    <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                            <span style={{ display: "inline-block", width: "31%" }}>
                                <Select 
                                    label="Tenant"
                                    data = {
                                        this.state.tenant_list && this.state.tenant_list.map((tenant) => (
                                            tenant.name_of_tenant
                                        ))
                                    }
                                    value={this.state.selectedCustomer}
                                    onChange={(s) => this.handleHardwareAssetCustomerChange(s)}
                                    searchable
                                    allowDeselect={false}
                                />
                            </span>
                            {/* <span style={{ display: "inline-block", paddingLeft: "5px", cursor: "pointer" }}>
                                    <Tooltip label="Click to create a new customer"><IconPlus color="#00abfb" onClick={() => this.openCustomerModal()} /></Tooltip>
                            </span> */}
                        </Paper>
                        :
                        undefined
                }
                    <Paper withBorder p="md" radius="md" display="block" m="5px" ref={this.scrollerRef} onScroll={this.handleAssetTableScroll}>
                        <Flex
                            justify="flex-start"
                            align="flex-start"
                            direction="row"
                            gap="md"
                            h="50px"
                        >
                            {this.state.dataView === false ? (
                                this.state.selectedCustomerId !== 0 ?
                                    <Button h="36px" onClick={() => this.openAddModal()}>
                                        + Add New Asset
                                    </Button> 
                                    :
                                    <Button h="36px" disabled>
                                        + Add New Asset
                                    </Button>
                                ) : this.state.selectedCustomerId !== 0 ? (
                                <Button h="36px" onClick={() => this.goToAddOrderPage()}>
                                    + Add New Order
                                </Button>
                                ) : (
                                <Button h="36px" disabled>
                                    + Add New Order
                                </Button>
                            )}
                            <span style={{marginLeft: "auto"}}><Switch size="xl" checked={this.state.dataView} onLabel="ORDERS" offLabel="ASSETS" onChange={(e) => this.handleViewChange(e.currentTarget.checked)}/></span>
                        </Flex>
                        <div style={{marginTop: "20px"}}></div>
                        {this.state.dataView === false ?        // if dataView is false, show asset stuff, otherwise show order stuff
                            <Flex
                                justify="flex-start"
                                align="flex-start"
                                direction="row"
                                gap="xl"
                            >
                                <Select 
                                    label="Device Type"
                                    placeholder="Select a value"
                                    data={
                                        this.state.types_list && this.state.types_list.map((item) => (
                                            item.name_of_type
                                        ))
                                    }
                                    value={this.state.selected_type_name}
                                    onChange={(s) => this.handleDeviceTypeFilterChange(s)}
                                    clearable
                                    searchable
                                />
                                <Select 
                                    label="Location"
                                    placeholder="Select a value"
                                    data={
                                        this.state.sites && this.state.sites.map((item) => (
                                            item.name_of_site
                                        ))
                                    }
                                    value={this.state.site_name_selected}
                                    onChange={(s) => this.handleSiteFilterChange(s)}
                                    clearable
                                    searchable
                                />
                                <Select 
                                    label="State"
                                    placeholder="Select a value"
                                    data={["Active - Assigned", "Active - Ready to Deploy", "Active - Loaner", "Inactive - Donated", "Inactive - Ewasted", "Inactive - Missing"]}
                                    value={this.state.state_selected}
                                    onChange={(s) => this.handleStateFilterChange(s)}
                                    clearable
                                    searchable
                                />
                                <Select 
                                    label="Model"
                                    placeholder="Select a value"
                                    data={
                                        this.state.models && this.state.models.map((item) => (
                                            item.name_of_model
                                        ))
                                    }
                                    value={this.state.model_name_selected}
                                    onChange={(s) => this.handleModelFilterChange(s)}
                                    clearable
                                    searchable
                                />
                                <div style={{ marginTop: "32px" }}>
                                    <Tooltip label="Reset Filters"><Button variant="light" color="red" onClick={() => this.resetAssetFilters()}><IconFilterX /></Button></Tooltip>
                                </div>
                                <div style={{ marginLeft: 'auto' }}><Text size="sm" component="span">{`Selected asset count: `}</Text><Text size="md" component="span" c="blue" fw={700}>{this.state.rowCount}</Text></div>
                            </Flex>

                            :

                            <Flex
                                justify="flex-start"
                                align="flex-start"
                                direction="row"
                                gap="xl"
                            >
                                <DatePickerInput
                                label="Date Range of Placement"
                                placeholder="Pick date"
                                w="350px"
                                type="range"
                                value={this.state.timespan}
                                onChange={(e) => {
                                    this.setState({ timespan: e });
                                    // Run async work without blocking the state update
                                    setTimeout(() => {
                                        this.handleOrderPlacementTimespanChange(e);
                                        //this.setState({ timespan: e })
                                    }, 0);
                                }}
                                allowDeselect={false}
                                />

                                <Select
                                    label="Order Status"
                                    placeholder="Pick a Value"
                                    data={["All", "Open", "Pending", "Completed", "Cancelled"]}
                                    value={this.state.orderStatusSelected}
                                    onChange={(e) => this.handleOrderStatusChange(e)}
                                    allowDeselect={false}
                                />
                                <div style={{ marginLeft: 'auto' }}><Text size="sm" component="span">{`Selected order count: `}</Text><Text size="md" component="span" c="blue" fw={700}>{this.state.rowCount}</Text></div>
                            </Flex>
                        }
                        <div style={{marginTop: "30px"}}></div>
                        <TextInput
                            placeholder="Search by asset name, assigned person name, or serial number"
                            mb="md"
                            leftSection={<IconSearch style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                            value={this.state.searchText}
                            onChange={this.onChangeSearchText}
                        />
                        {this.state.dataView === false ?    // show ASSETS if dataView is false
                            <>
                                <Table miw={700}>
                                    <Table.Tbody>
                                        <Table.Tr>
                                            <Th
                                                w="18%"
                                                sorted={this.state.sort_by === 'Name'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick("Name")}
                                            >
                                                <div className={this.state.sort_by === "Name" ? "activeMyAssignedTicketsHeader" : ""}>Name</div>
                                            </Th>
                                            <Th
                                                w="10%"
                                                sorted={this.state.sort_by === 'Type'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Type')}
                                            >
                                                <div className={this.state.sort_by === "Type" ? "activeMyAssignedTicketsHeader" : ""}>Type</div>
                                            </Th>
                                            <Th
                                                w="10%"
                                                sorted={this.state.sort_by === 'Model'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Model')}
                                            >
                                                <div className={this.state.sort_by === "Model" ? "activeMyAssignedTicketsHeader" : ""}>Model</div>
                                            </Th>
                                            <Th
                                                w="15%"
                                                sorted={this.state.sort_by === 'Assigned To'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Assigned To')}
                                            >
                                                <div className={this.state.sort_by === "Assigned To" ? "activeMyAssignedTicketsHeader" : ""}>Assigned To</div>
                                            </Th>
                                            <Th
                                                w="15%"
                                                sorted={this.state.sort_by === 'Location'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Location')}
                                            >
                                                <div className={this.state.sort_by === "Location" ? "activeMyAssignedTicketsHeader" : ""}>Location</div>
                                            </Th>
                                            <Th
                                                w="10%"
                                                sorted={this.state.sort_by === 'Serial Number'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Serial Number')}
                                            >
                                                <div className={this.state.sort_by === "Serial Number" ? "activeMyAssignedTicketsHeader" : ""}>Serial Number</div>
                                            </Th>
                                            <Th 
                                                w="10%"
                                                sorted={this.state.sort_by === 'State'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('State')}
                                            >
                                                <div className={this.state.sort_by === "State" ? "activeMyAssignedTicketsHeader" : ""}>State</div>
                                            </Th>
                                            <Th
                                                w="12%"
                                                sorted={this.state.sort_by === 'Warranty Expires'}
                                                reversed={this.state.sort_order === "ASC"}
                                                onSort={() => this.handleColumnClick('Warranty Expires')}
                                            >
                                                <div className={this.state.sort_by === "Warranty Expires" ? "activeMyAssignedTicketsHeader" : ""}>Warranty Expires</div>
                                            </Th>
                                        </Table.Tr>
                                    </Table.Tbody>
                                </Table>
                                <Box pos="relative">
                                    <LoadingOverlay
                                    visible={this.state.show_loading_indicator}
                                    zIndex={1000}
                                    overlayProps={{ radius: 'sm', blur: 2 }}
                                    loaderProps={{ color: 'blue', type: 'bars' }}
                                />
                                <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                                    <Table.Tbody>
                                        {rows && rows.length > 0 ? (
                                            rows
                                        ) : (
                                            <Table.Tr>
                                                <Table.Td>
                                                    <Text fw={500} ta="center">
                                                        Nothing found
                                                    </Text>
                                                </Table.Td>
                                            </Table.Tr>
                                        )}
                                    </Table.Tbody>
                                </Table>
                                </Box>
                            </>
                            :
                            // show ORDERS if dataView is true
                            <>
                                <Table miw={700}>
                                    <Table.Tbody>
                                        <Table.Tr>
                                            <Th
                                                w="12%"
                                                sorted={this.state.order_sort_by === 'Order Number'}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick("Order Number")}
                                            >
                                                <div className={this.state.order_sort_by === "Order Number" ? "activeMyAssignedTicketsHeader" : ""}>Order Number</div>
                                            </Th>
                                            <Th
                                                w="25%"
                                                sorted={this.state.order_sort_by === 'Order Name'}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick("Order Name")}
                                            >
                                                <div className={this.state.order_sort_by === "Order Name" ? "activeMyAssignedTicketsHeader" : ""}>Order Name</div>
                                            </Th>
                                            <Th
                                                w="18%"
                                                sorted={this.state.order_sort_by === 'PO Number'}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick('PO Number')}
                                            >
                                                <div className={this.state.order_sort_by === "PO Number" ? "activeMyAssignedTicketsHeader" : ""}>PO Number</div>
                                            </Th>
                                            <Th
                                                w="20%"
                                                sorted={this.state.order_sort_by === 'Customer'}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick('Customer')}
                                            >
                                                <div className={this.state.order_sort_by === "Customer" ? "activeMyAssignedTicketsHeader" : ""}>Customer</div>
                                            </Th>
                                            <Th
                                                w="15%"
                                                sorted={this.state.order_sort_by === "Date Placed"}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick("Date Placed")}
                                            >
                                                <div className={this.state.order_sort_by === "Date Placed" ? "activeMyAssignedTicketsHeader" : ""}>Date Placed</div>
                                            </Th>
                                            <Th
                                                w="10%"
                                                sorted={this.state.order_sort_by === 'Status'}
                                                reversed={this.state.order_sort_order === "ASC"}
                                                onSort={() => this.handleOrderColumnClick('Status')}
                                            >
                                                <div className={this.state.order_sort_by === "Status" ? "activeMyAssignedTicketsHeader" : ""}>Status</div>
                                            </Th>
                                        </Table.Tr>
                                    </Table.Tbody>
                                </Table>
                                <Box pos="relative">
                                    <LoadingOverlay
                                    visible={this.state.show_loading_indicator}
                                    zIndex={1000}
                                    overlayProps={{ radius: 'sm', blur: 2 }}
                                    loaderProps={{ color: 'blue', type: 'bars' }}
                                />
                                <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                                    <Table.Tbody>
                                        {orderRows && orderRows.length > 0 ? (
                                            orderRows
                                        ) : (
                                            <Table.Tr>
                                                <Table.Td>
                                                    <Text fw={500} ta="center">
                                                        Nothing found
                                                    </Text>
                                                </Table.Td>
                                            </Table.Tr>
                                        )}
                                    </Table.Tbody>
                                </Table>
                                </Box>
                            </>
                        }
                        <div style={{marginTop: "75px", textAlign: "center"}}>
                            {this.state.assetOffsetValue >= this.state.rowCount ?
                                <Text size="sm" fs="italic" style={{cursor: "default"}}>All records displayed</Text>
                                :
                                <Text size="sm" fs="italic" style={{cursor: "default"}}>Scroll down for more</Text>
                            }
                        </div>
                    </Paper>
                </Container>

                {/* This modal is for filtering contents of the hardware asset table */}
                <Modal
                    show={this.state.show_filter_modal}
                    onHide={() => this.closeFilterModal()}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    centered
                >
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Apply Filters to Assets</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group controlId="filterWarrantyStatus" className="mb-3">
                                <Form.Label>Warranty Status</Form.Label>
                                <div className="mb-3">
                                    <Form.Check
                                        inline
                                        checked={this.state.selected_warranty_status === "All"}
                                        label="All"
                                        name="waranty radio"
                                        type="radio"
                                        id="All Warranty Radio"
                                        value="All"
                                        onChange={e => { this.toggleFilterWarrantyDateInputVisible(false); this.handleWarrantyStatusFilterChange(e) }}
                                    />
                                    <Form.Check
                                        inline
                                        checked={this.state.selected_warranty_status === "In Date"}
                                        label="In Date"
                                        name="waranty radio"
                                        type="radio"
                                        id="In Date Warranty Radio"
                                        value="In Date"
                                        onChange={e => { this.toggleFilterWarrantyDateInputVisible(false); this.handleWarrantyStatusFilterChange(e) }}
                                    />
                                    <Form.Check
                                        inline
                                        checked={this.state.selected_warranty_status === "Expired"}
                                        label="Expired"
                                        name="waranty radio"
                                        type="radio"
                                        id="Expired Warranty Radio"
                                        value="Expired"
                                        onChange={e => { this.toggleFilterWarrantyDateInputVisible(false); this.handleWarrantyStatusFilterChange(e) }}
                                    />
                                    <Form.Check
                                        inline
                                        checked={this.state.selected_warranty_status === "Expires Between"}
                                        label="Expires Between"
                                        name="waranty radio"
                                        type="radio"
                                        id="Specific Date Warranty Radio"
                                        value="Expires Between"
                                        onChange={e => { this.toggleFilterWarrantyDateInputVisible(true); this.handleWarrantyStatusFilterChange(e) }}
                                    />
                                    <span style={{ display: "inline-block" }}>
                                        {this.state.enable_warranty_date_input ?
                                            <Form.Control type="date" name="warrantyExpiresDateStart" onChange={e => this.handleWarrantyStartDateChange(e)} defaultValue={this.state.selected_expiration_start_date}></Form.Control> :
                                            <Form.Control disabled type="date" name="warrantyExpiresDateStart" defaultValue={this.state.selected_expiration_start_date}></Form.Control>
                                        }
                                    </span>
                                    <span style={{ display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>
                                        <p className="gothamNarrowLightFont">and</p>
                                    </span>
                                    <span style={{ display: "inline-block" }}>
                                        {this.state.enable_warranty_date_input ?
                                            <Form.Control type="date" name="warrantyExpiresDateEnd" onChange={e => this.handleWarrantyEndDateChange(e)} defaultValue={this.state.selected_expiration_end_date}></Form.Control> :
                                            <Form.Control disabled type="date" name="warrantyExpiresDateEnd" defaultValue={this.state.selected_expiration_end_date}></Form.Control>
                                        }
                                    </span>
                                </div>
                            </Form.Group>
                            <Form.Group controlId="filterAssetType" className="mb-3">
                                <Form.Label>Asset Type</Form.Label>
                                <Form.Control as="select">
                                    {this.state.types_list && this.state.types_list.map((type) => (
                                        this.state.selected_type === type.id ?
                                            <option key={`type_${type.id}`} onClick={() => this.handleSelectedTypeChange(type.id)} selected>{type.name_of_type}</option>
                                            :
                                            <option key={`type_${type.id}`} onClick={() => this.handleSelectedTypeChange(type.id)}>{type.name_of_type}</option>

                                    ))}
                                    {/* <option>All</option>
                                        <option>Printer</option>
                                        <option>Workstation</option> */}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="filterTenantName" className="mb-3">
                                <Form.Label>Company</Form.Label>
                                <Form.Control as="select">
                                    {this.state.tenant_list && this.state.tenant_list.map((tenant) => (
                                        this.state.selected_tenant === tenant.id ?
                                            <option key={`tenant_${tenant.id}`} onClick={() => this.handleSelectedTenantChange(tenant.id)} selected>{`${tenant.name_of_tenant}`}</option>
                                            :
                                            <option key={`tenant_${tenant.id}`} onClick={() => this.handleSelectedTenantChange(tenant.id)}>{`${tenant.name_of_tenant}`}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="filterAssetOwner" className="mb-3">
                                <Form.Label>{`Assigned To (based on Company selected)`}</Form.Label>
                                <Form.Control as="select">
                                    {this.state.user_list && this.state.user_list.map((user) => (
                                        this.state.selected_assigned_to_user === user.id && (user.id !== 0 && user.id !== -1) ?
                                            <option key={`user_${user.id}`} onClick={() => this.handleSelectedAssignedUserChange(user.id)} selected>{`${user.full_name} - (${user.name_of_tenant})`}</option>
                                            :
                                            this.state.selected_assigned_to_user === user.id && (user.id === 0 || user.id === -1) ?
                                                <option key={`user_${user.id}`} onClick={() => this.handleSelectedAssignedUserChange(user.id)} selected>{`${user.full_name}`}</option>
                                                :
                                                this.state.selected_assigned_to_user !== user.id && (user.id !== 0 && user.id !== -1) ?
                                                    <option key={`user_${user.id}`} onClick={() => this.handleSelectedAssignedUserChange(user.id)}>{`${user.full_name} - (${user.name_of_tenant})`}</option>
                                                    :
                                                    <option key={`user_${user.id}`} onClick={() => this.handleSelectedAssignedUserChange(user.id)}>{`${user.full_name}`}</option>
                                    ))}
                                    {/* <option>All</option>
                                        <option>Test McTesterson</option>
                                        <option>Michael Childress</option> */}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="filterSerialNumber" className="mb-3">
                                <Form.Label>Serial Number</Form.Label>
                                <Form.Control type="text" placeholder="ex: 123abc758" value={this.state.selected_serial_number} onChange={e => this.handleSerialNumberChange(e)} />
                            </Form.Group>
                            <Form.Group controlId="filterAssetTag" className="mb-3">
                                <Form.Label>Asset Tag</Form.Label>
                                <Form.Control type="text" placeholder="ex: 123abc758" value={this.state.selected_asset_tag} onChange={e => this.handleAssetTagChange(e)} />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            {/* <div className="assetFilterResetButtonContainer">
                                <Button variant="danger" onClick={() => this.resetFiltersToDefaultValues()} className="gothamNarrowFont">Reset</Button>
                            </div> */}
                            <div style={{ paddingRight: "15px" }}>
                                <Button variant="secondary" onClick={() => this.closeFilterModal()} className="gothamNarrowFont">Cancel</Button>
                            </div>
                            <div>
                                <Button id="newDepartmentFormOkButton" onClick={() => { this.applyFilters() }} className="gothamNarrowFont">Apply</Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* This modal is for adding a new hardware asset to the system - NOT CURRENTLY USING, see Create Hardware Asset.js */}
                <Modal
                    show={this.state.show_add_modal}
                    onHide={() => this.closeAddModal()}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    centered
                >
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Add A New Hardware Asset</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* 
                                1. Asset type (drop down) required
                                2. Name of asset (text) required - must be unique
                                3. Model name (drop down) required
                                4. Vendor (drop down)
                                5. Asset tag (text)
                                6. Serial Number (text)
                                7. Bar code (text)
                                8. Acquisition date (date)
                                9. Warranty start date (date)
                                10. Warranty expiration date (date)
                                11. Site (drop down) required
                                12. Assigned person (drop down)
                                13. Assigned location at site (drop down)
                                14. Lease Start Date (date)
                                15. Lease End Date (date)
                                16. Manufacturer Website (text)
                                17. Asset Category (drop down) required
                                18. Is Tracked (radio) required
                                19. Core Asset Assigned To (drop down)
                            */}
                            <div className="addHardwareFormOuterWrapper" style={{ width: "100%" }}>
                                <Form.Group controlId="addFormAssetName" className="mb-3">
                                    <Form.Label>Asset Name<span className="requiredStar">*</span></Form.Label>
                                    <Form.Control type="text" placeholder="ex: Dell 3600c" required />
                                </Form.Group>

                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormAssetCategory" className="mb-3">
                                            <Form.Label>Asset Category<span className="requiredStar">*</span></Form.Label>
                                            <Form.Control as="select" required>
                                                <option>IT</option>
                                                <option>Non-IT</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>


                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormAssetType" className="mb-3">
                                            <Form.Label>Asset Type<span className="requiredStar">*</span></Form.Label>
                                            <Form.Control as="select" required>
                                                <option>Printer</option>
                                                <option>Workstation</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormAssetModel" className="mb-3">
                                            <Form.Label>Model Name<span className="requiredStar">*</span></Form.Label>
                                            <Form.Control as="select" required>
                                                <option>Thinkpad 2100</option>
                                                <option>PureVision 1080p</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormSite" className="mb-3">
                                            <Form.Label>Assigned Site<span className="requiredStar">*</span></Form.Label>
                                            <Form.Control as="select" required>
                                                <option>Irvine Office</option>
                                                <option>ProGroup Irvine</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormLocationAtSite" className="mb-3">
                                            <Form.Label>Location at Site</Form.Label>
                                            <Form.Control as="select">
                                                <option>None</option>
                                                <option>1F Aisle 3 Desk 5</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormAssignedPerson" className="mb-3">
                                            <Form.Label>Person Assigned To</Form.Label>
                                            <Form.Control as="select">
                                                <option>None</option>
                                                <option>Test McTesterson</option>
                                                <option>Techy Test-Tech</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <span style={{ display: "inline-block", width: "90%" }}>
                                        <Form.Group controlId="addFormAssetVendor" className="mb-3">
                                            <Form.Label>Vendor</Form.Label>
                                            <Form.Control as="select">
                                                <option>None</option>
                                                <option>McKesson</option>
                                                <option>ProGroup</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </span>
                                    <span style={{ display: "inline-block", paddingLeft: "15px" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <Form.Group controlId="addFormAssetTag" className="mb-3">
                                    <Form.Label>Asset Tag</Form.Label>
                                    <Form.Control type="text" placeholder="ex: John Smith's Laptop" />
                                </Form.Group>
                                <Form.Group controlId="addFormAssetSerialNumber" className="mb-3">
                                    <Form.Label>Serial Number</Form.Label>
                                    <Form.Control type="text" placeholder="ex: 1234abc789" />
                                </Form.Group>
                                <Form.Group controlId="addFormAssetBarCode" className="mb-3">
                                    <Form.Label>Bar Code</Form.Label>
                                    <Form.Control type="text" placeholder="ex: 0447789" />
                                </Form.Group>
                                <Form.Group controlId="addFormAcquisitionDate" className="mb-3">
                                    <Form.Label>Acquistion Date</Form.Label>
                                    <Form.Control type="date" name="addFormAcquisitionDate"></Form.Control>
                                </Form.Group>

                                <Form.Group controlId="addFormWarrantyDates" className="mb-3">
                                    <Form.Label>Warranty Start and End Dates</Form.Label>
                                    <div>
                                        <span style={{ display: "inline-block" }}>
                                            <Form.Control type="date" name="addFormWarrantyStartDate"></Form.Control>
                                        </span>
                                        <span style={{ display: "inline-block", paddingLeft: "15px", paddingRight: "15px" }}>
                                            to
                                        </span>
                                        <span style={{ display: "inline-block" }}>
                                            <Form.Control type="date" name="addFormWarrantyEndDate"></Form.Control>
                                        </span>
                                    </div>
                                </Form.Group>

                                <Form.Group controlId="addFormLeaseDates" className="mb-3">
                                    <Form.Label>Lease Start and End Dates</Form.Label>
                                    <div>
                                        <span style={{ display: "inline-block" }}>
                                            <Form.Control type="date" name="addFormLeaseStartDate"></Form.Control>
                                        </span>
                                        <span style={{ display: "inline-block", paddingLeft: "15px", paddingRight: "15px" }}>
                                            to
                                        </span>
                                        <span style={{ display: "inline-block" }}>
                                            <Form.Control type="date" name="addFormLeaseEndDate"></Form.Control>
                                        </span>
                                    </div>
                                </Form.Group>

                                <Form.Group controlId="addFormManufacturerWebsite" className="mb-3">
                                    <Form.Label>Manufacturer Website</Form.Label>
                                    <Form.Control type="text" placeholder="ex: https://www.dell.com" />
                                </Form.Group>

                                <Form.Group controlId="addFormTrackAsset" className="mb-3">
                                    <Form.Label>Track Asset</Form.Label>
                                    <div className="mb-3">
                                        <Form.Check
                                            inline
                                            defaultChecked
                                            label="Yes"
                                            name="track asset radio"
                                            type="radio"
                                            id="Yes Track Asset Radio"
                                        />
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="track asset radio"
                                            type="radio"
                                            id="No Do Not Track Asset Radio"
                                        />
                                    </div>
                                </Form.Group>

                                {/* NOTE: This field is used only for front end. It's not stored in the backend */}
                                <Form.Group controlId="addFormIsPeripheral" className="mb-3">
                                    <Form.Label>Is Peripheral</Form.Label>
                                    <div className="mb-3">
                                        <Form.Check
                                            inline
                                            label="Yes"
                                            name="peripheral radio"
                                            type="radio"
                                            id="Yes Is Peripheral Radio"
                                            onChange={() => this.toggleAddFormAssignedAssetInputVisible(true)}
                                        />
                                        <Form.Check
                                            inline
                                            defaultChecked
                                            label="No"
                                            name="peripheral radio"
                                            type="radio"
                                            id="Not Peripheral Radio"
                                            onChange={() => this.toggleAddFormAssignedAssetInputVisible(false)}
                                        />
                                    </div>
                                </Form.Group>

                                {this.state.enable_assigned_asset_input ?
                                    <div className="mb-3" style={{ width: "100%" }}>
                                        <span style={{ display: "inline-block", width: "33%" }}>
                                            <Form.Group controlId="addFormAssignedAssetCategory">
                                                <Form.Label>Assigned Asset Category</Form.Label>
                                                <Form.Control as="select">
                                                    <option>IT</option>
                                                    <option>Non-IT</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                        <span style={{ display: "inline-block", width: "33%" }}>
                                            <Form.Group controlId="addFormAssignedAssetType">
                                                <Form.Label>Assigned Asset Type</Form.Label>
                                                <Form.Control as="select">
                                                    <option>Printer</option>
                                                    <option>Workstation</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                        <span style={{ display: "inline-block", width: "33%" }}>
                                            <Form.Group controlId="addFormAssignedAssetName">
                                                <Form.Label>Assigned Asset Name</Form.Label>
                                                <Form.Control as="select">
                                                    <option>Lenovo Server 12345</option>
                                                    <option>Lenovo Monitor 6789</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                    </div> :

                                    <div className="mb-3" style={{ width: "100%" }}>
                                        <span style={{ display: "inline-block", width: "25%" }}>
                                            <Form.Group controlId="addFormAssignedAssetCategory">
                                                <Form.Label>Assigned Asset Category</Form.Label>
                                                <Form.Control as="select" disabled>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                        <span style={{ display: "inline-block", width: "25%" }}>
                                            <Form.Group controlId="addFormAssignedAssetType">
                                                <Form.Label>Assigned Asset Type</Form.Label>
                                                <Form.Control as="select" disabled>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                        <span style={{ display: "inline-block", width: "50%" }}>
                                            <Form.Group controlId="addFormAssignedAssetName">
                                                <Form.Label>Assigned Asset Name</Form.Label>
                                                <Form.Control as="select" disabled>
                                                </Form.Control>
                                            </Form.Group>
                                        </span>
                                    </div>
                                }

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{ paddingRight: "15px" }}>
                                <Button variant="secondary" onClick={() => this.closeAddModal()} className="gothamNarrowFont">Cancel</Button>
                            </div>
                            <div>
                                <Button id="newDepartmentFormOkButton" onClick={() => { this.closeAddModal() }} className="gothamNarrowFont">Apply</Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions,
        hardwareAssetFilter: state.hardwareAssetFilter
    };
}

export default connect(mapStateToProps, {
    LOGOUT,
    UPDATE_ACTIVE_LINK,
    UPDATE_SELECTED_TYPE,
    UPDATE_SELECTED_WARRANTY_STATUS,
    UPDATE_SELECTED_EXPIRATION_START_DATE,
    UPDATE_SELECTED_EXPIRATION_END_DATE,
    UPDATE_SELECTED_TENANT_ID,
    UPDATE_SELECTED_ASSIGNED_TO_USER,
    UPDATE_SELECTED_SERIAL_NUMBER,
    UPDATE_SELECTED_ASSET_TAG,
    UPDATE_SEARCH_TEXT_HARDWARE_ASSET,
    UPDATE_HARDWARE_ASSET_SORT_BY,
    UPDATE_HARDWARE_ASSET_SORT_ORDER,
    UPDATE_SELECTED_HARDWARE_ASSET_DATA_VIEW,
    UPDATE_SELECTED_HARDWARE_ASSET_CUSTOMER,
    UPDATE_ORDER_PLACEMENT_TIMESPAN,
    UPDATE_SELECTED_ORDER_STATUS,
    UPDATE_HARDWARE_ORDERS_SORT_BY,
    UPDATE_HARDWARE_ORDERS_SORT_ORDER
})(HardwareAssetList);